<template>
<div>
  <header class="ui grid container">
    <div class="sixteen wide tablet eight wide computer column logo">
      <router-link :to="{ name: 'home'}">
        <img class="ui medium image" src="../assets/images/SVG/zapparoli.svg">
      </router-link>
    </div>
    <div class="six wide tablet eight wide computer column menu-header">
      <div class="ui secondary menu menu-site">
    
          <router-link v-for="(route,index) in routes" :key="index" class="item" v-if="route.nav == true" :to="route.path ? route.path : '/'" :class="route.classes">{{route.titulo}}
          
    <div class="menu" v-if="route.dropdown">
        <router-link :to="{ name: 'tratamento', params: { id : item._id }}" class="item" v-for="(item, index) in route.dropdown" v-if="item.tratamentoAtivo">
          {{ item.titulo | truncate(25) }}
        </router-link>
  </div>
          
          </router-link>
   
      </div>
    </div>
 
  </header>


<div class="menu-bottom">
<div class="ui grid">
  <div class="eight wide column">
<div class="item">
       <i class="phone icon"></i>
<a :href="`tel:${dados.telefones.numero.replace(/ /g,'')}`">
          {{ dados.telefones.numero }}
        </a>
      </div>
  </div>
  <div class="eight wide column">
    <div class="item">  <i class="whatsapp icon"></i>
             <a target="_blank" :href="`http://wa.me/055${dados.telefones.whatsapp.replace(/ /g,'')}`">{{dados.telefones.whatsapp}}</a>
</div>
  </div>
  <div class="four wide column"></div>
</div>
</div>
<sidebar :menu="routes" ></sidebar>
  </div>
</template>

<script>
import { routes } from "../router.js";
import { siteConfig } from "../dados.js";
import { json } from "../assets/json.js";
import SideBarVue from '../components/SideBar.vue';
export default {
  components: {
        sidebar: SideBarVue // Register your component
    },
  data() {
    return {
      dados: siteConfig,
      tratamentos: "",
      routes,
      dropdown: false,
    };
  },
  created() {
    this.tratamentos = json;
  },
  mounted() {
 
  }
};
</script>
<style lang="scss" scoped>
header .column .menu .ui.item.dropdown {
  border-radius: 15px 15px 0 0 !important;
    font-weight: bold;
  .menu {
    border-radius: 0 10px 10px 10px;
    margin-top: 0px !important;
    .item {
      font-size: 1rem !important; 
      padding: 1rem 2rem !important;
      border-bottom: 2px solid rgba(0,0,0,0.02);
      border-radius: 0 !important;
    }
  }
}
</style>
